package com.eladfinish.bible.contest.screens.search.analytics

import com.eladfinish.bible.contest.screens.search.api.SearchAnalyticsApi
import com.eladfinish.contract.analytics.SearchAnalyticsEvent
import io.github.aakira.napier.Napier

class SearchAnalyticsTracker(
    private val api: SearchAnalyticsApi,
) {

    suspend fun trackSearch(
        event: SearchAnalyticsEvent,
    ) {
        runCatching {
            api.trackSearch(event)
        }.onFailure { throwable ->
            Napier.w(
                message = "Failed to track search analytics event",
                throwable = throwable,
            )
        }
    }
}
